import {
  BaseInfo,
  ResumeInfo,
  ResumeSimpleInfo,
  Remark,
  Attachment,
  FilterRecord,
  InterviewRecord,
  OriginResume
} from '@/interfaces/interviewer/detail'

export interface DetailModuleState {
  baseInfo?: BaseInfo
  resumeInfo?: ResumeInfo
  resumeSimpleInfo?: ResumeSimpleInfo
  remarks?: Remark[]
  attachments?: Attachment[]
  filterRecords?: FilterRecord[]
  interviewRecords?: InterviewRecord[]
  originResume?: OriginResume[]
}

export default {
  namespaced: true,
  state: () => ({
    baseInfo: {},
    resumeInfo: {},
    remarks: [],
    attachments: [],
    interviewRecords: []
  }),
  mutations: {
    setBaseInfo(state: DetailModuleState, info: BaseInfo) {
      state.baseInfo = info
    },

    setResumeInfo(state: DetailModuleState, info: ResumeInfo) {
      state.resumeInfo = info
    },
    setResumeSimpleInfo(state: DetailModuleState, info: ResumeSimpleInfo) {
      state.resumeSimpleInfo = info
    },
    setRemarks(state: DetailModuleState, remarks: Array<Remark>) {
      state.remarks = remarks
    },

    setAttachments(state: DetailModuleState, attachments: Array<Attachment>) {
      state.attachments = attachments
    },

    setInterviewRecords(
      state: DetailModuleState,
      records: Array<InterviewRecord>
    ) {
      state.interviewRecords = records
    },

    setFilterRecords(state: DetailModuleState, records: Array<FilterRecord>) {
      state.filterRecords = records
    }
  },
  actions: {},
  getters: {}
}
